import SetupStokAwal from "./SetupStokAwal"

export default SetupStokAwal